import { spacing } from './spacing';

export const radius = <const>{
  sm: `${spacing[1]}`,
  md: `${spacing[2]}`,
  lg: `${spacing[3]}`,
  full: '9999px',
};
